import PrecallSurvey from '@components/pages/account/survey/PrecallSurvey';
import { AEP_SurveyStep } from '@components/pages/account/survey/PrecallSurvey/constants';

export const PrecallAepProviders = () => <PrecallSurvey step={AEP_SurveyStep.PROVIDER} />;

export default PrecallAepProviders;
